import type { CalendarEventReminder } from "../Models/Domain";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateReminder } from "@/Services/TherapyApi/Calendars";
import CalendarEventReminderTransformer from "@/Modules/Transformers/Calendars/EventReminder";

import useCalendarsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

const updateCalendarEventReminder = async (
  reminder: CalendarEventReminder
): Promise<CalendarEventReminder | undefined> => {
  const calendarsStore = useCalendarsStore();
  const appStore = useAppStore();
  let eventReminder: CalendarEventReminder | undefined = undefined;

  try {
    const eventReminderApi = await updateReminder(
      reminder.uuid,
      CalendarEventReminderTransformer.toApi(reminder)
    );

    eventReminder = CalendarEventReminderTransformer.toDomain(eventReminderApi);
    calendarsStore.config!.reminders = calendarsStore.config!.reminders.map((r) => {
      if (r.uuid === eventReminder!.uuid) {
        return eventReminder!;
      }

      return r;
    });

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "calendars.menu.config.advice_policy.save_success",
    });
  } catch (e) {
    danger("Error updating config", e);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "calendars.menu.config.advice_policy.save_error",
    });
  }

  return eventReminder;
};

export default updateCalendarEventReminder;
